/**
 * Enum for image upload types
 * Used to determine the upload destination and processing logic
 */
export const ImageUploadType = {
    AssetImage: "assetImage",
    EmployeeImage: "employeeImage",
    InventoryImage: "inventoryImage",
    OrganizationImage: "organizationImage",
    ProductImage: "productImage"
};